export const deviceTypeList = [
	// { name: 'Umdasch', img: 'Umdasch_no-Soundbar' },
	{ name: 'Chromebox', img: 'Chromebox' },
	// { name: 'UmdaschLargeLowerScreen', img: 'Umdasch-2_no-Soundbar' },
	// { name: 'IsariaIAA', img: 'Isaria-IAA_2019' },
	// {
	// 	name: 'IsariaSoundbar',
	// 	img: 'Isaria-Prototype_Soundbar',
	// },
	// { name: 'Volke', img: 'Volke_Felgenspion' },
	// { name: 'EKiosk', img: 'eKiosk_Protoype' },
];
